<template>
  <v-navigation-drawer v-model="isDrawer" app color="primary">
    <v-list dark dense shaped>
      <!-- <v-list-item> -->
      <!-- <v-list-item-avatar>
        </v-list-item-avatar> -->
      <div class="text-center">
        <img src="@/assets/img/logo-contigo-seguros-white.png" height="50vw" alt="Contigo Seguro" @click="home">
      </div>
      <!-- </v-list-item> -->
      <v-divider></v-divider>

      <v-list-group color="accent" v-for="item in listMenu" :key="item.title" v-model="item.active"
        :prepend-icon="item.action" active-class="white--text" no-action>

        <template v-slot:activator>
          <v-tooltip color="primary" right>
            <template v-slot:activator="{ on }">
              <v-list-item-content v-on="on">
                <v-list-item-title class="white--text" v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-html="item.title"></span>
          </v-tooltip>
        </template>

        <v-list-item link v-for="subItem in item.items" :key="subItem.title" class="ml-6" style="padding:0"
          :active-class="!isDark ? 'active-list' : 'active-list-dark'"
          :class="_.isEqual(subItem.path,path) ? (!isDark ? 'active-list' : 'active-list-dark') : item.active ? (!isDark ? 'bg-grupo' : 'bg-grupo-dark') : '' "
          >
          <v-list-item-action>
            <v-icon class="white--text">{{ subItem.icon }}</v-icon>
          </v-list-item-action>

          <v-tooltip color="primary" right>
            <template v-slot:activator="{ on }">
              <v-list-item-content v-on="on" @click="onChangePath(subItem)">
                <!-- <router-link :to="subItem.path"  style="text-decoration: none" > -->
                  <v-list-item-title class="white--text" v-text="subItem.title"></v-list-item-title>
                <!-- </router-link> -->
              </v-list-item-content>
            </template>
            <span v-html="subItem.title"></span>
          </v-tooltip>
        </v-list-item>

      </v-list-group>
    </v-list>
    <!-- <v-footer fixed style="background-color: #ee4637; height: -1">
      <v-container grid-list-md text-xs-center>
        <v-row class="text-center">
          <v-col>
            <v-divider></v-divider>
            <span class="caption" style="margin:0px auto; color: #ffe0e0;">Contigo Seguro © 2019</span>
            <v-spacer></v-spacer>
            <span class="caption" style="color: #ffa3a3;">Desarrollado por Viamatica S.A.</span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer> -->
  </v-navigation-drawer>
</template>

<script>
  export default {
    props: {
      source: String,
      drawer: {
        type: Boolean,
        default: true
      },
      menu: {
        type: Array,
        required: true,
        default: []
      }
    },
    data: () => ({
      path: null,
      listMenu:[],
      isDrawer: false
    }),
    computed:{
      isDark(){
        var isDark = _.get(this,['$vuetify','theme','dark'],false);
        return isDark;
      }
    },
    watch:{
      drawer(val){
        this.isDrawer = val;
      },
      isDrawer(val){
        if(this.drawer != val)
          this.$root.drawer = val;
      },
      menu(val){
        this.$set(this,'listMenu',val);
      }
    },
    methods: {
      home() {
        this.$router.push('/main');
      },
      onChangePath(v) {
        if(!_.isEqual(this.path,v.path)){
          new Promise((resolve,reject)=>{
              this.$set(this,'path',v.path);
              this.$router.push(v.path);
            return resolve(true)
          })
          .then((r)=>{
            this.updateMenu();
          });
        }

      },
      updateMenu(){
        var menu = _.cloneDeep(this.listMenu);
        menu = _.map(menu, (v, k) => {
                    var o = _.find(v.items,{'path':this.path});
                    this.$set(v,'active',!_.isUndefined(o) ? true : false);
                  return v;
                });

        this.$set(this,'listMenu',menu);
      }
    },
    mounted() {
      this.path = this.$router.currentRoute.path;
      this.isDrawer = this.drawer;
      this.listMenu = this.menu;
      this.updateMenu();
    }
  }
</script>
<style type="text/css">
  .active-list {
    background-color: #b11b1b !important;
  }

  .bg-grupo {
    background-color: rgb(209, 77, 66) !important;
  }
  .active-list-dark {
    background-color: #BDBDBD !important;
  }

  .bg-grupo-dark {
    background-color: #212121 !important;
  }
</style>